export default __webpack_public_path__ + "static/media/best-price.1fa73457.png";